import type { TotalRecordingDurationCondition } from "@repo/app-types/entities/filterConditions";
import { asSeconds } from "@repo/app-types/units/duration";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import { SimpleMenuSection } from "@repo/ui/Menu/simpleMenuSection";
import type { FC } from "react";
import { SubmenuTrigger } from "react-aria-components";

export interface TotalRecordingDurationFilterOptionProps {
  value: TotalRecordingDurationCondition | null;
  onChange: (newValue: TotalRecordingDurationCondition | null) => void;
}

export const TotalRecordingDurationFilterOption: FC<
  TotalRecordingDurationFilterOptionProps
> = (props) => {
  // If the filter is already set, don't show the option to add another.
  if (props.value !== null) {
    return null;
  }

  return (
    <SubmenuTrigger>
      <SimpleMenuItem>Call duration</SimpleMenuItem>

      <SimpleMenuPopover>
        <SimpleMenu aria-label="Filter by call duration">
          <SimpleMenuSection label="is over">
            {[2, 5, 10, 30, 60].map((minutes) => (
              <SimpleMenuItem
                key={minutes}
                onAction={() =>
                  props.onChange({
                    operator: ">=",
                    value: asSeconds(minutes * 60),
                  })
                }
              >
                {minutes} min
              </SimpleMenuItem>
            ))}
          </SimpleMenuSection>

          <SimpleMenuSection label="is under">
            {[5].map((minutes) => (
              <SimpleMenuItem
                key={minutes}
                onAction={() =>
                  props.onChange({
                    operator: "<",
                    value: asSeconds(minutes * 60),
                  })
                }
              >
                {minutes} min
              </SimpleMenuItem>
            ))}
          </SimpleMenuSection>
        </SimpleMenu>
      </SimpleMenuPopover>
    </SubmenuTrigger>
  );
};
